import React from "react";
import { Container, Button } from "react-bootstrap";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { utilityServices } from "./servicesConfig";

const GOLD = "#ebb51b";
const GOLD_DARK = "#a67a10";
const BG_HEADER = "#33353a";
const TEXT_ON_PAGE = "#f4f4f5";
const TEXT_MUTED = "#9a9ca1";

const OutlineButton = ({ children, onClick, style, ...props }) => (
  <Button
    onClick={onClick}
    className="uw-outline-btn d-flex align-items-center gap-2 fw-semibold shadow-none border-0"
    style={{
      backgroundColor: "transparent",
      color: GOLD_DARK,
      border: `1.5px solid ${GOLD}`,
      borderRadius: "0",
      fontSize: "0.82rem",
      padding: "8px 16px",
      whiteSpace: "nowrap",
      ...style,
    }}
    {...props}
  >
    {children}
  </Button>
);

const NavbarUtility = ({ title }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Trova il servizio attivo in base alla route se la prop title non viene passata
  const activeService = utilityServices.find(
    (service) => service.route === location.pathname
  );

  const displayTitle = title || (activeService ? activeService.title : "Utility Web");

  return (
    <div
      style={{
        backgroundColor: BG_HEADER,
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        padding: "16px 30px",
      }}
    >
      <Container fluid>
        {/* Layout Unico In-Line: Home + Titolo + Voci Utility */}
        <div className="d-flex align-items-center gap-4 flex-wrap">
          
          {/* Pulsante Home */}
          <OutlineButton onClick={() => navigate("/home")}>
            <ArrowLeft size={16} />
            Home
          </OutlineButton>

          {/* Titolo Dinamico da Props / Route */}
          <div className="d-flex flex-column pe-3 border-end border-secondary border-opacity-25">
            <span
              style={{
                color: GOLD,
                fontSize: "0.70rem",
                fontWeight: 700,
                letterSpacing: "1.5px",
                textTransform: "uppercase",
                lineHeight: 1,
              }}
            >
              Utility Web
            </span>

            <h2
              className="mb-0 fw-bold"
              style={{
                fontFamily: "'Oswald', sans-serif",
                color: TEXT_ON_PAGE,
                fontSize: "1.5rem",
                lineHeight: 1.2,
              }}
            >
              {displayTitle}
            </h2>
          </div>

          {/* Servizi In-Line: Icona sopra, Titolo sotto, zero box */}
          <div className="d-flex align-items-center gap-4 overflow-auto py-1">
            {utilityServices.map((service) => {
              const IconComponent = service.icon;
              const isActive =
                location.pathname === service.route || service.title === displayTitle;

              return (
                <div
                  key={service.title}
                  onClick={() => navigate(service.route)}
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{
                    cursor: "pointer",
                    color: isActive ? GOLD : TEXT_MUTED,
                    borderBottom: isActive ? `2px solid ${GOLD}` : "2px solid transparent",
                    paddingBottom: "4px",
                    transition: "all 0.2s ease-in-out",
                    userSelect: "none",
                  }}
                >
                  <IconComponent size={20} color={isActive ? GOLD : TEXT_MUTED} />
                  <span
                    className="fw-semibold mt-1"
                    style={{
                      fontSize: "0.78rem",
                      whiteSpace: "nowrap",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {service.title}
                  </span>
                </div>
              );
            })}
          </div>

        </div>
      </Container>
    </div>
  );
};

export default NavbarUtility;